import React, { useEffect } from "react"; // <-- add useEffect here
  import { Container, Row, Col } from 'react-bootstrap';
  import { FaCheckCircle } from 'react-icons/fa';
  import '../styles/aboutHeader.css';

  const AboutHeader = () => {
      useEffect(() => {
        window.scrollTo(0, 0); // <-- This forces scroll to top
      }, []);
    return (
      <div className="about-header-section">
        <Container fluid>
          <Row className="align-items-center flex-column-reverse flex-md-row">
            <Col md={6} className="image-container">
              <img
                src="/images/SEPL_Resize.png"
                alt="About AV"
                className="about-image"
              />
            </Col>

            <Col md={6} className="text-content">
              {/* <p className="about-small-heading">Who we are</p> */}
              <h2 className="about-main-heading">We are Aligned Vertical</h2>
              <p className="about-description">
                We are a passionate team of IT professionals committed to delivering reliable, scalable, and secure technology solutions. With a strong understanding of modern business needs, we design and implement digital systems that empower organizations to thrive in a connected world.
              </p>

              {/* Horizontal Icons */}
              <div className="feature-horizontal-wrap mt-4">
                <div className="feature-item-horizontal">
                  <img src="/images/team.png" alt="Team" className="feature-icon-small" />
                  <span className="feature-label-horizontal">Best IT Team</span>
                </div>
                <div className="feature-item-horizontal">
                  <img src="/images/pie-chart.png" alt="Infra" className="feature-icon-small" />
                  <span className="feature-label-horizontal">Secure Infrastructure</span>
                </div>
              </div>

              {/* Tick Icon Grid */}
              <Row className="tick-feature-grid mt-4">
                {[
                  "24/7 Support",
                  "Client Satisfaction",
                  "Quality Assurance",
                  "Skilled Developers",
                  "Transparent Process",
                  "On-Time Delivery"
                ].map((label, index) => (
                  <Col xs={12} sm={6} className="tick-feature-item" key={index}>
                    <FaCheckCircle className="tick-icon" />
                    <span className="tick-label">{label}</span>
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>
        </Container>
        <div style={{ paddingBottom: '20px' }}></div>

<Row className="mission-vision-section">
  <Col md={6}>
    <p className="section-heading">Our Mission</p>
    <p className="section-subheading">Innovate with Purpose</p>
    <p className="section-description">
      We aim to leverage technology to create efficient and reliable digital ecosystems. Our mission is to enable businesses to excel through innovation and adaptive solutions that evolve with market needs.lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
    </p>

    <p className="section-subheading">Empowering Transformation</p>
    <p className="section-description">
      Driving digital change that impacts lives. We focus on empowering clients through customized IT solutions that are scalable and future-ready.loram ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
    </p>
  </Col>

  <Col md={6}>
    <p className="section-heading">Our Vision</p>
    <p className="section-subheading">Future-Driven Solutions</p>
    <p className="section-description">
      To be a global leader in delivering cutting-edge technologies and software development that shapes the future of industries.
    </p>

    <p className="section-subheading">Sustainable Innovation</p>
    <p className="section-description">
      We envision a future where businesses and technology evolve together responsibly, creating a lasting impact on society and the environment.
    </p>
  </Col>
</Row>

<div className="our-story-section text-center position-relative">
  {/* Top Right Image */}
  {/* <figure className="decoration-img top-right">
    <img src="images/background_02.png" alt="Top Decoration" />
  </figure>

 
  <figure className="decoration-img bottom-left">
    <img src="images/background_O1.png" alt="Bottom Decoration" />
  </figure> */}

  <h2 className="our-story-heading">Our Story..</h2>
  <p className="our-story-subheading">
    Exponential year over year growth since 2004 … <strong>and we’re just …<br /> getting started.</strong>
  </p>
</div>







      </div>
      
      
    );
  };

  export default AboutHeader;
